let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("aEpRh"), load("6hlNE"), load("K6fhx"), load("1y1eN"), load("jqwnR"), load("lsloj")]).then(() => parcelRequire('kHBbC'));